import * as React from "react";
import { useGetList } from "ra-core";
import DashboardCard from "src/components/dashboard-components/DashboardCard";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  AreaChart,
  Area,
} from "recharts";
import { Box, useTheme } from "@mui/material";

export function RevenueGraph(props) {
  const { sx, rest, days = 30 } = props;

  const [filter, setFilter] = React.useState({});
  const [orders, setOrders] = React.useState([]);

  React.useEffect(() => {
    setFilter({
      "created_at.from": new Date(
        Date.now() - days * 24 * 60 * 60 * 1000
      ).toISOString(),
    });
  }, []);

  const { data } = useGetList("admin/orders", {
    pagination: { page: 1, perPage: 10 },
    sort: { field: "created_at", order: "ASC" },
    filter: { ...filter, "status.in": "complete,delivered" },
  });

  const theme = useTheme();

  React.useEffect(() => {
    let groupedOrders = {};
    data?.map((order) => {
      const date = order.created_at.substring(0, 11);

      if (!groupedOrders[date]) {
        groupedOrders[date] = [];
      }
      groupedOrders[date].push(order);
    });
    let newOrders = [];
    Object.keys(groupedOrders).forEach((key) => {
      newOrders.push({
        name: key,
        value: groupedOrders[key].reduce(
          (accumulator, item) => accumulator + item.total,
          0
        ),
      });
    });

    setOrders(newOrders);
  }, [data]);

  return (
    <DashboardCard
      {...rest}
      sx={sx}
      title="Revenue"
      subheader={`in the last ${days} days`}
    >
      <Box display="flex" alignItems="center" padding="10px">
        <LineChart width={700} height={400} data={orders}>
          <Line
            type="monotone"
            dataKey="value"
            style={{ margin: 10 }}
            stroke={theme.palette.primary.main}
          />
          <XAxis dataKey="name" stroke="#65748b" />
          <YAxis stroke="#65748b" />
        </LineChart>
      </Box>
    </DashboardCard>
  );
}
